import { getAction } from "@/api/cloud/manage";
import Toast from "vant/lib/toast";
import axios from "axios";
// 增加loading 效果
async function checkVersion() {
  try {
    const res = await axios.get(
      `https://erp.aipesticides.com/api/jeecg-system/sys/api/selectAppVersion`
    );
    const localVersion = localStorage.getItem("version");
    if (res.status === 200) {
      const version = res.data.find((item) => item.itemValue === localVersion);
      if (!version) {
        // 由于无法在原生APP 中增加loading 效果,所以在此之前增加提示
        console.log("版本号不一致，重新请求资源");

        let second = 3;
        const timer = setInterval(() => {
          second--;
          if (second) {
            Toast.loading({
              message: `版本更新中,请稍后...`,
              duration: 0, // 持续展示 toast
              forbidClick: true,
            });
          } else {
            // 写入新的版本号到 localStorage
            const lastVersion = res.data[res.data.length - 1].itemValue;
            localStorage.setItem("version", lastVersion);
            clearInterval(timer);
            Toast.clear();
            window.location.reload(true);
          }
        }, 1000);

        // 版本不一致
        // let _obj = {
        //   msgType: "clearCache",
        //   data: { clearType: "data" },
        // };

        // // 这里清除全部缓存
        // interaction.bridge(_obj).then((res) => {
        //   window.location.reload(true);
        //   console.log("版本号不一致，重新请求资源");
        // });

        // this.$store.commit("SET_APP_VERSION", lastVersion);
      }
    }
  } catch (error) {
    console.log(error, "获取版本号error");
  } finally {
    Toast.clear();
  }
}

export default checkVersion;
